import { Icon } from '@cbhq/cds-web/icons';
import { Box } from '@cbhq/cds-web/layout';

import { tileLockedColor, tileLockedStyle } from ':cloud/widgets/buildQuest/assets/colors';
import { TileOutlined } from ':cloud/widgets/buildQuest/TileOutlined';

export function LockedTile(): React.ReactElement {
  return (
    <Box position="relative">
      <TileOutlined className={tileLockedStyle} />
      <Box position="absolute" bottom={25} left={121}>
        <Icon name="lock" size="m" dangerouslySetColor={tileLockedColor} />
      </Box>
    </Box>
  );
}
